module.exports = __webpack_public_path__ + "img/肌如初雪套装_09.63cc21c5.jpg";